<template>
  <v-container fluid>
  <div class="omr-title">
    Your OMR
  </div>
    <div class="omr-preview">
      <img :src="data.omr_link"/>
    </div>
    <div class="download-omr">
    <v-btn color="primary"  class="cust-btn margin-right-5" @click="download">  
      Download
    </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "OmrPreview",
  props: ["onClose", "status", "data"],
  data() {
    return {
    };
  },
  methods: {
    download(){
      let token = sessionStorage.getItem("auth_token");
      let url = process.env.VUE_APP_API_URL + `/omr/download/${this.data.omr_id}?token=${token}`;
      window.open(url, "_blank");
    }
  },
};
</script>
